import {
  FETCH_USER_EXISTING_COURSE,
  FETCH_USER_EXISTING_COURSE_INFO,
  STUDENT_LOGIN_LOADER,
  USER_LOGIN,
  USER_LOGIN_INFO,
  USER_PROFILE_INFO,
  USER_LOGOUT
} from "../../constants/ActionTypes";


export const showUserLoader = (isLoading) =>({
  type: STUDENT_LOGIN_LOADER,
  payload: isLoading
})

export const userLogin = (data, navigate, courseInfo, endorsementCourseInfo, directCoursesInfo) => ({
  type: USER_LOGIN,
  payload: data,
  navigate,
  courseInfo,
  endorsementCourseInfo,
  directCoursesInfo
});

export const userLoginInfo = (data) => ({
  type: USER_LOGIN_INFO,
  payload: data,
});

export const userProfileInfo = (data) => ({
  type: USER_PROFILE_INFO,
  payload: data,
})

export const fetchUserExistingCourse = (data) => ({
  type: FETCH_USER_EXISTING_COURSE,
  payload: data,
})

export const fetchUserExistingCourseInfo = (data) => ({
  type: FETCH_USER_EXISTING_COURSE_INFO,
  payload: data,
});
export const userLogout = () => ({
  type: USER_LOGOUT,
});